import React from 'react'
import { useHeapEvents } from '@toasttab/shared/src/hooks/useHeapEvents'

const PageElement = ({ children }: any) => {
  useHeapEvents('isCustomer', 'isCustomer')

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export default PageElement
